export class ImagePopUp {
    init()
    {
        $('.picture a, .image a').magnificPopup({
            type: 'image',
            closeOnContentClick: true,
            closeBtnInside: false,
            fixedContentPos: true,
            mainClass: 'mfp-no-margins mfp-with-zoom',
            image: {
                verticalFit: true
            },
            zoom: {
                enabled: true,
                duration: 300
            }
        });
        $('.swiper-container a').magnificPopup({
            type: 'image'
        });
        $('.slider-investitions .slider__item').magnificPopup({
            type: 'image'
        });
    }
}